import { Component, signal, inject, effect } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { AuthService } from './core/services/auth-service';

@Component({
  selector: 'nexa-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('nexa-app');
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  private readonly postLoginRedirect = effect(() => {
    const user = this.authService.user();
    if (!user) return;

    const redirect = localStorage.getItem('redirectAfterLogin');
    if (redirect) {
      localStorage.removeItem('redirectAfterLogin');
      this.router.navigateByUrl(redirect);
    } else if (location.pathname === '/' || location.pathname === '/login') {
      this.router.navigateByUrl('/overview');
    }
  });
}
